// IMPORTS
import axios from 'axios'
import _ from 'lodash'
import Db from './../../dixie.js'

// DEFINITIONS
const state = {
    isLoaded: false,
    pedidoData: {
        usuario: {},
        pedido_headers: {},
    }
};

const getters = {
    readData: (state) => { return state.pedidoData },
    isLoaded: (state) => { return state.isLoaded }
};

const mutations = {
    setPedido: (state, payload) => {
        state.pedidoForProc = payload
    },
    setData: (state, payload) => {
        payload.total = 0;
        _.map(payload.data, prod => { payload.total += parseFloat(prod.total);});
        payload.total = parseInt(payload.total * 100) / 100 // DEBE SER FLOTANTE PERO SÓLO CON CENTAVOS, O SE MUERE PAYPAL...
        Db.configs
            .where('key')
            .equalsIgnoreCase('payload')
            .delete()
            .then(()=>{
                Db.configs.add({
                    key: 'payload',
                    value: JSON.stringify(payload)
                });
		});
        state.pedidoData = payload;
        state.isLoaded = true;
    },
    pedidoClean: (state) => {
		Db.configs.where('key').equalsIgnoreCase('payload').delete()
        state.pedidoData = {}
	}
};

const actions = {
    recoverFromDixie: ({commit}) => {
		return new Promise(( success ) => {
            Db.configs.where('key')
                .equalsIgnoreCase('payload')
                .first()
                .then( payload => {
                    commit('setData', JSON.parse(payload.value))
                    success('Session recovered from dixie')
                })
                .catch(d => {
                    success('No session available')
                })
		})
    },
    makePaid: ({commit, getters}, payload) => {
        return new Promise((success, fail) => {

            // DATA PREPARATION
            let data2send = _.clone(getters.readData)
            data2send.paypal_charge = payload

            // PROCESS
            axios.post('paypal/makepaid', data2send)
                .then((response) => {
                    if(response.status){
                        commit('pedidoClean')
                        success(response)
                    } else {
                        fail()
                    }
                }).catch((e) => {
                    console.error("e", e)
                    fail()
                })
        })
    },
    loadPedido: ({commit}, payload) => {
        return new Promise((success, fail) => {
            let data2send = _.merge(payload, {bd: 'jalisco'})
            axios.post('pedidos/detalle', data2send)
                .then((response) => {
                    if(response.status){
                        commit('setData', _.merge(response, data2send))
                        success()
                    } else {
                        fail()
                    }
                }).catch((e) => {
                    console.error("e", e)
                    fail()
                })
        })
    }
};

// EXPORTS
export default {
	state,
	getters,
	mutations,
	actions
};



// WEBPACK FOOTER //
// ./src/store/modules/pedido.js